/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkActionResult } from './InstanceBulkActionResult';
import {
    InstanceBulkActionResultFromJSON,
    InstanceBulkActionResultFromJSONTyped,
    InstanceBulkActionResultToJSON,
} from './InstanceBulkActionResult';

/**
 * 
 * @export
 * @interface ExecuteInstanceBulkDecision200Response
 */
export interface ExecuteInstanceBulkDecision200Response {
    /**
     * 
     * @type {InstanceBulkActionResult}
     * @memberof ExecuteInstanceBulkDecision200Response
     */
    data?: InstanceBulkActionResult;
}

/**
 * Check if a given object implements the ExecuteInstanceBulkDecision200Response interface.
 */
export function instanceOfExecuteInstanceBulkDecision200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecuteInstanceBulkDecision200ResponseFromJSON(json: any): ExecuteInstanceBulkDecision200Response {
    return ExecuteInstanceBulkDecision200ResponseFromJSONTyped(json, false);
}

export function ExecuteInstanceBulkDecision200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteInstanceBulkDecision200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : InstanceBulkActionResultFromJSON(json['data']),
    };
}

export function ExecuteInstanceBulkDecision200ResponseToJSON(value?: ExecuteInstanceBulkDecision200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': InstanceBulkActionResultToJSON(value.data),
    };
}

